export const ROLE_GENERAL: any = {
    USER_DEFAULT: 'user',
    ADMIN: 'admin',
    SUPER_ADMIN: 'superadmin'
}

export const COLOR_PRIMARY = '#26695c';

export const ROLE_DETAIL: any = {
    'user': {
        title: 'Người dùng',
        status: 'gray'
    },
    'admin': {
        title: 'Quản trị viên',
        status: '#ef9d00'
    },
    'superadmin': {
        title: 'Quảng lý cấp cao',
        status: 'orangered'
    }
}

export const USER_STATE: any = {
    0: {
        title: 'Không hoạt động',
        state: 'default'
    },
    1: {
        title: 'Hoạt động',
        state: 'success'
    },
    2: {
        title: 'Chờ xác nhận',
        state: 'warning'
    },
}

export const listOptionChannelStatus: Array<any> = [
    {
        label: 'Tất cả',
        value: 'all'
    },
    {
        label: 'Kênh chết',
        value: 'die'
    },
    {
        label: 'Kênh bị gậy',
        value: 'stuck'
    }
];

export const listOptionFieldVideo: Array<any> = [
    {
        label: 'View, cao đến thấp',
        value: 'wave_timeline_view desc'
    },
    {
        label: 'View, thấp đến cao',
        value: 'wave_timeline_view asc'
    },
    {
        label: 'Subscribe, cao đến thấp',
        value: 'wave_timeline_subscribe desc'
    },
    {
        label: 'Subscribe, thấp đến cao',
        value: 'wave_timeline_subscribe asc'
    }
];

export function linearGradient(color: string, colorState: string, angle = 195) {
    return `linear-gradient(${angle}deg, ${color}, ${colorState})`;
}

export const optionSelectPickerType = [
    {
        value: 'date 24h-lastest',
        name: '24h gần nhất',
        disabled: false
    },
    {
        value: 'date 7-days',
        name: '7 ngày qua',
        disabled: false
    },
    {
        value: 'date 28-days',
        name: '28 ngày qua',
        disabled: false
    },
    {
        value: 'date 90-days',
        name: '90 ngày qua',
        disabled: false
    },
    {
        value: 'date 365-days',
        name: '365 ngày qua',
        disabled: false
    },
    {
        value: 'date all-days',
        name: 'Toàn thời gian',
        disabled: false
    },
    {
        value: 'week',
        name: 'Thống kê: Theo tuần',
        disabled: false
    },
    {
        value: 'month',
        name: 'Thống kê: Theo tháng',
        disabled: false
    },
    {
        value: 'quarter',
        name: 'Thống kê: Theo quý',
        disabled: false
    },
    {
        value: 'year',
        name: 'Thống kê: Theo năm',
        disabled: false
    },
    {
        value: 'date custom',
        name: 'Tùy chỉnh',
        disabled: false
    },
];

export const fileTypeDocument = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
export const fileXLSXExtension = '.xlsx';
export const generalVietnameseDateFormat = 'DD-MM-YYYY';
export const generalDefaultDateFormat = 'YYYY-MM-DD';

export const DEFAULT_PERPAGE = 50;
export const DEFAULT_PAGESIZE = [50, 100, 200, 300];

export const rangeTimeType = ['00:00:00 ', '23:59:59 '];